import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sue_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const adminAuth = {
  setToken(t) { localStorage.setItem("sue_admin_token", t); },
  getToken() { return localStorage.getItem("sue_admin_token"); },
  clear() { localStorage.removeItem("sue_admin_token"); localStorage.removeItem("sue_admin_email"); },
  setEmail(e) { localStorage.setItem("sue_admin_email", e); },
  getEmail() { return localStorage.getItem("sue_admin_email"); },
  isAuthed() { return !!localStorage.getItem("sue_admin_token"); },
};
